<template>
  <vue-draggable-resizable :x="initX" :y="160" :w="36" :h="36" delay="1" :fallbackTolerance="3" :resizable="false"
    class="risk-remind" parent=".devOps_producerSpace" @dragstop="onDragstop">
    <div class="self_menu_warp">
      <svg @click.stop="handleFlagIcon" class="self_menu_icon" aria-hidden="true" parent="#app">
        <use xlink:href="#icon-caidan"></use>
      </svg>
      <div class="self_menu_fadeslide_warp" :class="{ fadeSlideIn: showIcon}" v-if="visible">
        <Service />
      </div>
    </div>
  </vue-draggable-resizable>
</template>
<script>
import Service from './service.vue'
import { mapState } from 'vuex';
export default {
  components: { Service },
  data() {
    return {
      showIcon: false,
      visible: false,
      initX: document.documentElement.clientWidth - 50,
      isClick: true
    }
  },
  computed: {
    ...mapState(
      {
        users: (state) => state.devOps.ALLSELECT.TEXTUSERS,
      }
    )
  },
  mounted() {
    // console.log(document.documentElement.clientWidth)
  },
  methods: {
    // 点击展示
    handleFlagIcon() {
      if (!this.isClick) {
        return;
      }
      this.showIcon = !this.showIcon;
      this.visible = !this.visible;
    },
    onDragstop() {
      this.isClick = false;
      setTimeout(()=>{
        this.isClick = true
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.risk-remind {
  z-index: 1000 !important;
  border: none;
  left: 0;
  top: 0;
}

.self_menu_icon {
  width: 20px;
  height: 20px;
  fill: #fff;
  overflow: hidden;
  background-color: #1ab394;
  padding: 8px;
  border-radius: 50%;
  box-shadow: 0 0 7px -3px #707070;
  margin-top: 5px;
}

.self_menu_warp {
  position: fixed;
  display: flex;
  flex-direction: column-reverse;
  cursor: pointer;
  z-index: 100;

  .self_menu_fadeslide_warp {
    display: none;
    flex-direction: column;
    margin-bottom: -3px;
    position: absolute;
    bottom: 40px;
  }

  .fadeSlideIn {
    animation: in 0.2s 1;
    animation-fill-mode: forwards;
    display: flex;
  }

  @-webkit-keyframes in {
    0% {
      opacity: 0;
      transform: translateY(0);
      display: block;
    }

    100% {
      opacity: 1;
      transform: translateY(-5px);
    }
  }

  .fadeSlideOut {
    animation: out 0.2s 1;
    animation-fill-mode: forwards;
    display: flex;
  }

  @-webkit-keyframes out {
    0% {
      opacity: 1;
      transform: translateY(-5px);
    }

    100% {
      opacity: 0;
      transform: translateY(0);
      display: none;

    }
  }
}
</style>